import { logWithOffset } from "./logWithOffset";
import { urlToAbsolute } from './urlToAbsolute';

export default class KlarnaLocal {
  constructor(props) {
    this.props = props;
    this.session = null;
    this.klarnaContainer = document.getElementsByClassName("checkout-klarna-container")[0];
    if (this.klarnaContainer) {
      this.setup();
    }
  }

  loadSnippet(snippet) {
    this.klarnaContainer.innerHTML = snippet;
    const scriptsTags = this.klarnaContainer.getElementsByTagName('script')
    // This is necessary otherwise the scripts tags are not going to be evaluated
    for (let i = 0; i < scriptsTags.length; i++) {
        const parentNode = scriptsTags[i].parentNode
        const newScriptTag = document.createElement('script')
        newScriptTag.type = 'text/javascript'
        newScriptTag.text = scriptsTags[i].text
        parentNode.removeChild(scriptsTags[i])
        parentNode.appendChild(newScriptTag)
    }

  }

  async updateCountry(newCountry) {
    if (this.klarnaContainer) {
      await this.loadKlarnaPayments(newCountry);
      console.log(`Klarna handler ${newCountry}`);  
    }
  }

  disableKlarna() {
    [...document.querySelectorAll('input[name="combo_mode"][value="klarna"]')].forEach(x => x.checked = false);
    document.getElementsByTagName("body")[0].classList.add("klarna-disabled");
    document.getElementsByTagName("body")[0].classList.remove("klarna-enabled");
  }

  async loadKlarnaPayments(country) {
    console.log(`loadKlarnaPayments ${country} ${this.klarnaMethod}`);

    Klarna.Payments.load({
      container: this.klarnaContainer,
      payment_method_category: this.klarnaMethod
    }, {
      purchase_country: country,
    },function(res) {
      console.log(res);
      if (res.show_form) {
        document.getElementsByTagName("body")[0].classList.add("klarna-enabled");
        document.getElementsByTagName("body")[0].classList.remove("klarna-disabled");
        console.log("Klarna successfully loaded");
      } else {
        this.disableKlarna();
      }
    });
  }


  async authorize(ccData) {
    // Causes an update to occur to the klarna record reflecting the latest order.
    console.log("Calling apiClient.initKlarna");
    //await this.props.apiClient.initKlarna();

    const klarnaData = {
      purchase_country: ccData.billing.country,
      billing_address: {
        given_name: ccData.billing.first_name,
        family_name: ccData.billing.last_name,
        email: ccData.email,
        street_address: ccData.billing.address1,
        street_address2: ccData.billing.address2,
        postal_code: ccData.billing.postal_code,
        city: ccData.billing.city,
        region: ccData.billing.state,
        phone: ccData.billing.phone,
        country: ccData.billing.country
      },
      shipping_address: {
        given_name: ccData.shipping.first_name,
        family_name: ccData.shipping.last_name,
        email: ccData.email,
        street_address: ccData.shipping.address1,
        street_address2: ccData.shipping.address2,
        postal_code: ccData.shipping.postal_code,
        city: ccData.shipping.city,
        region: ccData.shipping.state,
        phone: ccData.shipping.phone,
        country: ccData.shipping.country
      }
    };

    const taxCart = await this.props.apiClient.klarnaCheckout({
      ccData
    });

    if (!taxCart.cart) {
      alert("Unable to process this Klarna transaction");
      return;
    }


    window.Klarna.Payments.authorize({
      payment_method_category: this.klarnaMethod
    }, klarnaData, async (res) => {
      console.log("Maybe?");
      console.log(res);

      if (res.approved) {
        const checkoutResult = await this.props.apiClient.klarnaCheckout({
          ccData,
          authorization: res,
          session: this.session
        });

        if (checkoutResult.success === true) {
          window.location = this.nextUrl;
        }
        console.log(checkoutResult);
      }

    });
  }

  async klarnaAsyncCallback() {

    this.session = await this.props.apiClient.initKlarna();
    console.log(this.session);
    if (!this.session.client_token) {
      console.log("Disabling Klarna");
      this.disableKlarna();
      return;
    }
    window.Klarna.Payments.init({
      client_token: this.session.client_token
    });

    await this.loadKlarnaPayments(checkout.klarnaHandler.props.initialCart.shippingZone);

  }

  setup() {
    // We are sure at this point that klarnaContainer exists.
    logWithOffset("Configuring Klarna");
    window.klarnaAsyncCallback = this.klarnaAsyncCallback.bind(this);
    this.klarnaMethod    = this.klarnaContainer.dataset.paymentMethod;
    this.nextUrl         = urlToAbsolute(this.klarnaContainer.dataset.checkoutNextUrl);
    const head      = document.getElementsByTagName('head')[0];
    const newScript = document.createElement("script");
    newScript.src   = 'https://x.klarnacdn.net/kp/lib/v1/api.js';
    newScript.async = false;
    head.appendChild(newScript);
  }

}
